/**
 * 内容打印实体
 * zxw
 * 2024-04-02 
 */

import { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import {
    Modal,
    Button,
    // Radio,
    ConfigProvider,
} from 'antd';
import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { tomorrow } from 'react-syntax-highlighter/dist/esm/styles/prism';
import 'katex/dist/katex.min.css';
import htmlDocx from 'html-docx-js/dist/html-docx';
import { saveAs } from 'file-saver';
import { CurrentDate, Html2pdf } from '../../incs/FunHelper';

import { renderNetworkData } from './FunNetworkData';

const AssistantBoxView = (props) => {
    const [propsState, setPropsState] = useState(props);
    const [format, setFormat] = useState('PDF');
    const [networkDataItem, setNetworkDataItem] = useState(null);
    const cancel = () => { setPropsState({ isModalOpen: false }); };

    const printer = () => {

        const printWindow = window.open('', '_blank');
        printWindow.document.write('<html><head>');
        printWindow.document.write('<link rel="stylesheet" href="https://xinzhiteng.oss-cn-shenzhen.aliyuncs.com/css/github-markdown.css"></link>');
        printWindow.document.write('<link rel="stylesheet" href="https://xinzhiteng.oss-cn-shenzhen.aliyuncs.com/css/katex.min.css"></link>');
        printWindow.document.write('<title>' + props.title + '</title>');
        printWindow.document.write('</head><body>');
        printWindow.document.write('<div style="width:820px;margin:0 auto;">');
        printWindow.document.write(document.getElementById('print-view-id').innerHTML);
        printWindow.document.write('</div>');
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    };
    const download = () => {
        if (format === 'PDF') {
            pdf();
        } else if (format === 'WORD') {
            word();
        } else {
            return;
        }
    };

    const pdf = () => { Html2pdf('print-view-id', props.content.split('\n')[0].slice(0, 50) + '.', CurrentDate()); }

    const word = () => {
        var html = '<html lang="zh-CN"><head>';
        html += '<meta charset="utf-8">';
        html += '<link rel="stylesheet" href="https://xinzhiteng.oss-cn-shenzhen.aliyuncs.com/css/github-markdown.css"></link>';
        html += '</head><body>';
        html += '<div style="text-align:center;width:100%;">';
        html += '<h1>' + props.title + '</h1>';
        html += '</div>';
        html += document.getElementById('print-view-mk-id').innerHTML;
        html += '</body></html>';

        var converted = htmlDocx.asBlob(html);
        saveAs(converted, props.content.split('\n')[0].slice(0, 50) + '.' + CurrentDate() + '.docx');
    }

    useEffect(() => {
        setPropsState(props);
        let currentNetworkData = props.networkData;
        let _networkDataItem = currentNetworkData && currentNetworkData.find(item => item.id === props.index);
        if (_networkDataItem) {
            setNetworkDataItem(_networkDataItem);
        }
    }, [props])

    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: global.THEMECOLOR,
                },
            }}
        >
            <Modal
                width={820}
                style={{ top: 0 }}
                maskClosable={true}
                closable={false}
                open={propsState.isModalOpen}
                keyboard={true}
                onCancel={cancel}
                afterClose={() => {
                    //  指令输入框获取焦点
                    document.getElementById('chat-question-id') && document.getElementById('chat-question-id').focus();
                    props.senderRef && props.senderRef.current.focus({ cursor: 'end', });
                }}
                footer={[
                    // <Radio.Group key='format' onChange={(e)=>{
                    //     setFormat(e.target.value);
                    // }} value={format}>
                    //     <Radio value='PDF'>PDF</Radio>
                    //     <Radio value='WORD'>WORD</Radio>
                    // </Radio.Group>,
                    <Button key='back' onClick={cancel}>取消</Button>,
                    <Button key='printer' type='primary' onClick={printer}>打印</Button>,
                    <Button key='link' type='primary' onClick={download}>下载</Button>,
                ]}
            >
                <div id='print-view-id'>
                    <div style={{ padding: '5px 15px' }}>
                        <div style={{ margin: '10px' }}>
                            <div style={{ display: 'inline-block', width: '50%', textAlign: 'left' }}><img crossOrigin='anonymous' src='https://xinzhiteng.oss-cn-shenzhen.aliyuncs.com/images/logos/logo-head.png' height='45px' alt={props.preGroup} /></div>
                            {
                                props.preGroup === 'xzt' ? <div style={{ display: 'inline-block', width: '50%', textAlign: 'right' }}><img crossOrigin='anonymous' src='https://xinzhiteng.oss-cn-shenzhen.aliyuncs.com/images/logos/page-header-right.png' height='35px' alt='新致腾' /></div> : ''
                            }
                        </div>
                        <div id='print-view-mk-id'>
                            <div id='print-antv-g2-id'></div>
                            {   //  渲染联网数据
                                networkDataItem ? renderNetworkData(networkDataItem, false, 'print-antv-g2-id') : ''
                            }
                            <ReactMarkdown
                                className={'markdown-xzt'}
                                children={props.content}
                                remarkPlugins={[[remarkGfm, { singleTilde: false }], remarkMath]}
                                rehypePlugins={[rehypeKatex]}
                                components={{
                                    code(props) {
                                        const { children, className, node, ...rest } = props
                                        const match = /language-(\w+)/.exec(className || '')
                                        return match ? (
                                            <SyntaxHighlighter
                                                {...rest}
                                                PreTag="div"
                                                children={String(children).replace(/\n$/, '')}
                                                language={match[1]}
                                                style={tomorrow}
                                            />
                                        ) : (
                                            <code {...rest} className={className}>
                                                {children}
                                            </code>
                                        )
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Modal>
        </ConfigProvider>
    );
};

export default AssistantBoxView;